import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'components';
import { Constants, Globals, checkPermission } from 'utils';
import { ConversionService } from 'services';

interface Props {
	onClose: any;
	dispatch: any;
}

class ModalExchange extends React.Component<Props> {

	state = {
		form: {
			conversion: 1
		}
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await ConversionService.admin.get();
		if (res.conversion) {
			this.setState({
				form: {
					conversion: res.conversion?.amount || 1
				}
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (checkPermission(Constants.MODULES.EXCHANGE,'write')) {
			await ConversionService.admin.update({
				amount: this.state.form.conversion
			});
			Globals.showSuccess("Se ha actualizado la tasa de cambio");
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-exchange">
				<p className="title-currency">Tasa de cambio del día (BCV)</p>
				<form onSubmit={ this.submit }>
					<div className="text-center">
						<Input
							disabled={ !checkPermission(Constants.MODULES.EXCHANGE,'write') }
							color="white"
							value={ this.state.form.conversion }
							name="conversion" 
							placeholder="Cantidad de Bs./$"
							onChange={ this.change } />
					</div>
					{
						checkPermission(Constants.MODULES.EXCHANGE,'write') && (
							<div className="text-center">
								<Button type="submit">
									Guardar
								</Button>
							</div>
						)
					}
				</form>
			</div>
		)
	}
}

export default ModalExchange;